import { fetch } from '../../utils';
import Backend from '../../backend';

export const getConfiguration = () => {
  return fetch(Backend.methodUrl('configurations'), {
    method: 'GET'
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};
